import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useRef, useState } from "react";
import program_moduleService from "../../../services/program_service/program_module.service";


export const CreateProgramAssesmentModal: React.FC<any> = ({
  isOpenAssessment,
  onClosed,
  isAssessment = false,
  reload
}: {
  isAssessment: boolean;
  isOpenAssessment: any;
  onClosed: any;
  reload: any;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const [assType, setassType] = useState<any[]>(['class',
    'field', 'solar', 'leadership']);
    const modalSize = useBreakpointValue({ base: "xs", sm: "sm", md: "sm" });

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.name) {
        errors.name = "Name is required";
      }
      if (!values.code) {
        errors.code = "Code is required";
      }

      return errors;
    },
    initialValues: {
      name: "",
      code: "",
      description: "",
      grade: "",
      type: ""
    },
    onSubmit: async (values) => {
      try {
        
        const AssessmentDto: any = {
          name: values.name,
          code: values.code,
          description: values.description,
          grade: values.grade,
          type: values.type
        };

        const createAssessment = await program_moduleService.createModuleCategory(
          AssessmentDto
        );
        
        //trying something

        if (createAssessment) {
          onClosed();
          reload()
          toast({
            title: "Program Assessment",
            description: "Assessment created successfully",
            status: "success",
            duration: 2000,
          });
        }
      } catch (error) {
        toast({
          title: "Program Assessment",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpenAssessment && isAssessment}
        onClose={onClosed}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size={modalSize}
      >
        <ModalOverlay />
        <ModalContent borderRadius={5}>
          <ModalHeader>
            {
              <Text
                fontSize={20}
                // pb={3}
                // textTransform="uppercase"
                // pl={3}
                color="brand.2"
              >
                Create Assessment
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="md" />
          <ModalBody pb={4}>
            <Box mt={2}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mt={2}
                  isInvalid={
                    formik.errors.name && formik.touched.name ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={14}>
                    Assessment Name
                  </FormLabel>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter name"
                    onChange={formik.handleChange}
                    fontSize={14}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.name}
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  mt={2}
                  isInvalid={
                    formik.errors.code && formik.touched.code ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={14}>
                    Assessment Code
                  </FormLabel>
                  <Input
                    type="text"
                    id="code"
                    name="code"
                    placeholder="Enter code"
                    onChange={formik.handleChange}
                    fontSize={14}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.code}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={2}
                  isInvalid={
                    formik.errors.grade && formik.touched.grade ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={14}>
                    Assessment Grade
                  </FormLabel>
                  <Input
                    type="number"
                    id="grade"
                    name="grade"
                    placeholder="Enter grade"
                    onChange={formik.handleChange}
                    fontSize={14}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.grade}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mt={2}
                  isInvalid={
                    formik.errors.name && formik.touched.name ? true : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={14}>
                    Assessment Type
                  </FormLabel>
                  <Select
                    variant="outline"
                    size="md"
                    value={formik.values.type}
                    placeholder="select assessment type"
                    name="type"
                    onChange={formik.handleChange}
                    fontSize={12}

                  >
                    {assType.map((each: any,index) => (
                      <option key={index} value={each}>
                        {" "}
                        {each}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.type}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  id="description"
                  mt={2}
                  isInvalid={
                    formik.errors.description && formik.touched.description
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={14}>
                    Description
                  </FormLabel>
                  <Textarea
                    p={4}
                    bg="inputText.500"
                    fontSize={12}
                    size="sm"
                    minH="6rem"
                    placeholder="Enter Description"
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.description}
                  </FormErrorMessage>
                </FormControl>

                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      size="sm"
                      px={6}
                      fontSize={12}
                      ref={cancelRef}
                      onClick={() => onClosed()}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      Confirm
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
